export default __webpack_public_path__ + "static/media/top1.1b7895e7.svg";